/* eslint-disable max-lines */
import { grey } from '@material-ui/core/colors';
import createTheme from '@material-ui/core/styles/createTheme';

export const variables = createTheme({
  palette: {
    primary: {
      contrastText: '#fff',
      dark: '#05144D',
      light: '#223D80',
      main: '#0D2772',
    },
    secondary: {
      main: '#0D2772',
    },
    success: {
      main: '#4CAF50',
    },
    error: {
      main: '#dc3f53',
    },
    grey: {
      50: '#fafafa',
      100: '#EEEEEE',
      200: '#E8E8E8',
      300: '#DDDDDD',
      400: '#818B9D',
      500: '#546E7A',
    },
  },
});

export const theme = createTheme({
  typography: {
    fontFamily: '"Roboto","Helvetica Neue", "Arial",sans-serif',
  },
  palette: variables.palette,
  shadows: variables.shadows,
  props: {
    MuiInput: {
      disableUnderline: true,
    },
    MuiFilledInput: {
      disableUnderline: true,
    },
    MuiInputLabel: {
      shrink: true,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        //lineHeight: 1,
        borderRadius: '0',
        textTransform: 'inherit',
        boxShadow: 'none',
        padding: '7.75px 16px',
        minHeight: 40,
      },
      contained: {
        boxShadow: 'none',
      },
      outlined: {
        padding: '6.75px 16px',
      },
      text: {
        padding: '7.75px 16px',
      },
      outlinedPrimary: {
        borderColor: '#D9D9D9',
        color: '#000000D9',
        '&:hover': {
          borderColor: '#D9D9D9',
          backgroundColor: '#F5F5F5',
        },
      },
    },
    MuiInput: {
      root: {
        color: 'rgba(0, 0, 0, 0.87)',
        padding: 0,
        ['label + &' as any]: {
          marginTop: '0.5rem',
        },
        ['& div + input' as any]: {},
        '&$error': {
          borderColor: variables.palette.error.main,
        },
      },
      disabled: {
        cursor: 'not-allowed',
      },
      formControl: {
        padding: 0,
        ['label + &' as any]: {
          marginTop: '0.5rem',
        },
      },
      input: {
        backgroundColor: '#FFFFFF',
        border: '1px solid #D9D9D9',
        fontSize: 16,
        padding: '9.5px 16px 9.5px 8px',
        width: 'calc(100% - 24px)',
        transition: 'border-color, box-shadow, 0.3s',
        '&:focus': {
          borderColor: variables.palette.secondary.main,
          zIndex: 10,
        },
      },
      inputMultiline: {
        boxSizing: 'border-box',
        width: '100%',
        minHeight: 80,
      },
      multiline: {
        padding: 0,
        minHeight: 80,
      },
    },
    MuiInputBase: {
      input: {
        padding: '9.5px 0 9.5px',
      },
    },
    MuiFilledInput: {
      root: {
        backgroundColor: '#FFFFFF',
        padding: 0,
        ['label + &' as any]: {
          marginTop: '0.5rem',
        },
        ['& div + input' as any]: {},
        '&$error': {
          borderColor: variables.palette.error.main,
        },
      },
      formControl: {
        padding: 0,
        ['label + &' as any]: {
          marginTop: '0.5rem',
        },
      },
      input: {
        backgroundColor: '#FFFFFF',
        border: '1px solid #D9D9D9',
        fontSize: 16,
        padding: '9px 16px 8px 8px',
        width: 'calc(100% - 24px)',
        transition: 'border-color, box-shadow, 0.3s',
        '&:focus': {
          borderColor: variables.palette.secondary.main,
          boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
          zIndex: 10,
        },
      },
      inputMultiline: {
        padding: 16,
        boxSizing: 'border-box',
        width: '100%',
        minHeight: 80,
      },
      multiline: {
        padding: 0,
        minHeight: 80,
      },
      // ['& > Textarea' as any]: {
      //   // height: 130
      // },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 0,
      },
    },
    MuiInputLabel: {
      root: {
        color: '#192542',
        fontSize: 15,
        fontWeight: 400,
        marginBottom: '0',
        display: 'block',
      },
      filled: {
        fontSize: 15,
        fontWeight: 400,
        marginBottom: '0',
        display: 'block',
      },
      shrink: {
        transform: 'translate(0, 0) scale(1)',
      },
      formControl: {
        position: 'relative',
      },
    },
    MuiFormControlLabel: {
      label: {
        fontSize: 15,
        color: '#192542',
        fontWeight: 400,
      },
    },
    MuiFormLabel: {
      root: {
        color: '#192542',
        '&$error': {
          color: variables.palette.error.main,
        },
        '&$focused': {
          color: variables.palette.secondary.main,
        },
      },
    },
    MuiSwitch: {
      root: {
        width: 44,
        height: 22,
        padding: 0,
        margin: '0 6px 0 11px',
      },
      switchBase: {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&$checked + $track': {
          backgroundColor: variables.palette.primary.main,
          color: '#ffff',
          opacity: 1,
        },
        '&$checked': {
          transform: 'translateX(22px)',
        },
      },
      thumb: {
        boxSizing: 'border-box',
        width: 18,
        height: 18,
        backgroundColor: '#fff',
      },
      track: {
        borderRadius: 26 / 2,
        backgroundColor: '#BFBFBF',
        opacity: 1,
        transition: variables.transitions.create(['background-color'], {
          duration: 500,
        }),
      },
    },
    MuiInputAdornment: {
      root: {
        border: '1px solid #d9d9d9',
        maxHeight: '100%',
        backgroundColor: 'white',
        height: '100%',
      },
      positionStart: {
        backgroundColor: 'white',
        marginRight: -2,
        position: 'relative',
        minWidth: 44,
        justifyContent: 'center',
        height: 40,
        borderRight: 'none',

        '& p': {
          fontSize: 15,
        },
        ['& button' as any]: {
          height: '100%',
          padding: '8px 16px',
        },
      },
      positionEnd: {
        backgroundColor: 'white',
        marginLeft: '-2px',
        minWidth: 44,
        justifyContent: 'center',
        height: 40,
        borderLeft: 'none',

        '& p': {
          fontSize: 15,
        },
      },
    },
    MuiSelect: {
      select: {
        backgroundColor: '#FFFFFF',
        border: '1px solid #D9D9D9',
        '&:focus': {
          borderColor: variables.palette.secondary.main,
          boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
          backgroundColor: '#FFFFFF',
        },
        disabled: {
          cursor: 'not-allowed',
        },
      },
    },
    MuiBreadcrumbs: {
      root: {
        fontSize: 14,
      },
      ol: {
        color: '#000000d9',
      },
    },
    MuiTabs: {
      root: {
        borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
      },
      indicator: {
        backgroundColor: '#FFBC00',
      },
    },
    MuiTab: {
      root: {
        textAlign: 'left',
        textTransform: 'initial',
        fontSize: 14,
        color: '#000000D9',
        fontWeight: 400,
        minWidth: '72px !important',
      },
      wrapper: {
        position: 'relative',
        zIndex: 2,
      },
      textColorPrimary: {
        color: '#000000d9',
        '&$selected': {
          color: '#000000d9',
          fontSize: 16,
        },
      },
    },
    MuiChip: {
      root: {
        backgroundColor: variables.palette.primary.light,
        color: 'white',
        margin: '4px 2px',
        borderRadius: 0,
      },
    },
    MuiPaper: {
      root: {
        borderRadius: 0,
        '&:not([role="alert"])': {
          border: '1px solid #D9D9D9',
        },
      },
      rounded: {
        borderRadius: 0,
      },
    },
    MuiCard: {
      root: {
        borderRadius: 0,
        border: '1px solid #D9D9D9',
      },
    },
    MuiTypography: {
      caption: {
        fontSize: '0.8rem',
        color: grey[600],
        letterSpacing: 0,
      },
      subtitle2: {
        fontSize: 15,
        lineHeight: '19px',
        color: grey[700],
        fontWeight: 400,
      },
    },
    MuiTablePagination: {
      root: {
        borderBottom: 0,
      },
      input: {
        border: '1px solid #ddd',
        minWidth: 60,
        borderRadius: 4,
      },
      selectIcon: {
        top: 2,
        width: 22,
      },
      caption: {
        fontSize: 13,
      },
    },
    MuiTableHead: {
      root: {
        '& th': {
          fontWeight: 600,
        },
      },
    },
    MuiBadge: {
      badge: {
        padding: '0 4px',
        letterSpacing: -0.4,
        fontSize: 13,
        fontWeight: 600,
      },

      anchorOriginTopRightCircle: {
        top: '6%',
        right: '6%',
      },
    },
  },
});
